import ListItemText from '@mui/material/ListItemText'
import { CircularProgress, LinearProgress, ListItemButton, Stack, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import PropTypes from 'prop-types'

export default function NotificationItem({ notification, onClick, section }) {
  const { title, date, type, read } = notification

  const renderText = (
    <ListItemText
      primary={title}
      secondary={
        <Stack
          direction='row'
          alignItems='center'
          sx={{ typography: 'caption2', color: 'text.secondary' }}
          divider={
            <Box
              sx={{
                width: 2,
                height: 2,
                bgcolor: 'currentColor',
                mx: 0.5,
                borderRadius: '50%',
              }}
            />
          }
        >
          {date}
          {type}
        </Stack>
      }
      primaryTypographyProps={{
        mb: 0.5,
        color: 'inherit',
        textDecoration: 'none',
        typography: 'subtitle1',
      }}
    />
  )

  const renderUnReadBadge = read === false && (
    <Box
      sx={{
        top: 26,
        width: 8,
        height: 8,
        right: 20,
        borderRadius: '50%',
        bgcolor: 'info.main',
        position: 'absolute',
      }}
    />
  )

  const renderLoading = section === 'processing' && (

    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" value={(notification.processed / notification.total) * 100} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: 'text.secondary' }}
        >
          {`${((notification.processed / notification.total) * 100).toFixed(0)}%`}
        </Typography>
      </Box>
    </Box>
  )


  return (
    <ListItemButton
      disableRipple
      onClick={onClick}
      sx={{
        p: 2.5,
        alignItems: 'flex-start',
        borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,
        flexDirection: 'row',

      }}
    >
      {renderUnReadBadge}
      {renderText}
      {renderLoading}
    </ListItemButton>
  )
}

NotificationItem.propTypes = {
  notification: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  section: PropTypes.string,
}
